import { render, staticRenderFns } from "./team-gpx-tab.vue?vue&type=template&id=02996315&scoped=true"
import script from "./team-gpx-tab.vue?vue&type=script&lang=js"
export * from "./team-gpx-tab.vue?vue&type=script&lang=js"
import style0 from "./team-gpx-tab.vue?vue&type=style&index=0&id=02996315&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02996315",
  null
  
)

export default component.exports